import { render, staticRenderFns } from "./form-dataRange.vue?vue&type=template&id=1ca85e47&"
import script from "./form-dataRange.vue?vue&type=script&lang=js&"
export * from "./form-dataRange.vue?vue&type=script&lang=js&"
import style0 from "./form-dataRange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports